import styled from 'styled-components';

import { fadeIn } from '../../../styles/shared.style';

export const Container = styled.section`
  position: absolute;
  flex-direction: column;
  top: 36px;
  left: 805px;
  display: flex;
  width: 381px;
  height: calc(100vh - 138px);
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
`;

export const SummaryHeader = styled.section`
  display: flex;
  align-items: center;
  width: 100%;
  height: 72px;
  gap: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  padding: 7px 0;

  img {
    padding-left: 20px;
    width: 48px;
    height: 48px;
  }

  h1 {
    font-family: 'Elza', sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 24.2px;
    letter-spacing: 0.016em;
    text-align: left;
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const Detailing = styled.section`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
  flex: 1;
  /* Lets the ticket list give way (and scroll) to the footer, whose height now depends on the fees block. */
  min-height: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.surface.base};
`;

export const SummaryFooter = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 100%;
  padding: 16px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.surface.high};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  gap: 12px;
`;

export const NoTicketsContainer = styled.section<{ $inView: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 12px;
  opacity: 0;
  animation: ${({ $inView }) => ($inView ? fadeIn : 'none')} 1s forwards;
`;

export const InfoContainer = styled.section`
  display: flex;
  width: 333px;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  h1 {
    margin: 0;
    font-family: 'Elza', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 22.4px;
    text-align: center;
    color: ${({ theme }) => theme.colors.text};
  }

  h2 {
    margin: 0;
    max-width: 287px;
    font-family: 'Elza', sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 14.52px;
    text-align: center;
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const RowFullWidth = styled.section<{
  $align: 'center' | 'space-between';
}>`
  display: flex;
  justify-content: ${({ $align }) => $align};
  width: 333px;
`;

export const TextInfo = styled.span<{ $weight: number; size: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Elza', sans-serif;
  font-size: ${({ size }) => size}px;
  font-weight: ${({ $weight }) => $weight};
  line-height: 19.36px;
  text-align: center;
  gap: 4px;
`;

export const Copyright = styled.section`
  display: flex;
  gap: 4px;

  & strong,
  span {
    font-family: Roboto;
    font-size: 10px;
    font-weight: 400;
    line-height: 11.72px;
    text-align: left;
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  & span {
    color: ${({ theme }) => theme.colors.button.text.disabled};
  }
`;

export const SelectedTickets = styled.section`
  width: 100%;
  flex: 1;
  max-height: calc(100vh - 400px);
  padding: 16px 24px 16px 24px;
  border: 1px 0px 1px 0px;
  opacity: 0px;
  overflow-y: scroll;
  overflow-x: hidden;
  opacity: 0;
  animation: ${fadeIn} 1s forwards;
`;

export const Ticket = styled.section<{ $hasError: boolean }>`
  display: flex;
  width: 100%;
  gap: 4px;
  margin-bottom: 24px;
  animation: fadeIn 1s forwards;
  z-index: 9999999999;

  .quantity,
  .details,
  .value {
    display: flex;
  }

  .quantity {
    width: 7%;

    span {
      font-family: 'Elza', sans-serif;
      font-size: 14px;
      font-weight: 400;
      line-height: 16.94px;
      text-align: center;
      color: ${({ theme, $hasError }) => $hasError ? theme.colors.error : theme.colors.accent.primary};
    }
  }

  .details {
    width: 68%;
    flex-direction: column;
    gap: 4px;

    .title,
    .value,
    .date,
    .sub-title
    {
      width: 100%;
      font-family: 'Elza', sans-serif;
      font-size: 14px;
      font-weight: 400;
      line-height: 16.94px;
      text-align: left;
    }

    .sub-title, .value {
      color: ${({ theme, $hasError }) => $hasError ? theme.colors.error : theme.colors.text};
    }

    .title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 800;

      color: ${({ theme, $hasError }) => $hasError ? theme.colors.error : theme.colors.text};
    }

    
    .date {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        font-size: 10px;
        line-height: 12.1px;
        margin-top: 4px;
        
        img {
          margin-left: 4px;
        }
      }
  }

  .total {
    width: 25%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: 3px;

  .text-link {
    background-color: transparent;
    padding: 0;
    margin: 0;
    font-family: 'Elza', sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 14.52px;
    text-align: center;
    color: ${({ theme : { colors } }) => colors.accent.primary};
    
    &:hover {
      background-color: transparent;
    }
  }

    .value {
      font-family: 'Elza', sans-serif;
      font-size: 12px;
      font-weight: 700;
      line-height: 14.52px;
      text-align: right;
      white-space: nowrap;
    }
  }
`;

export const Fees = styled.section`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  font-family: 'Elza', sans-serif;
`;

export const FeesRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
`;

export const FeesTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const FeesInfoTrigger = styled.button`
  display: flex;
  align-items: center;
  padding: 0;
  line-height: 0;
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }
`;

export const FeesValue = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const FeesToggle = styled.button`
  display: flex;
  align-items: center;
  align-self: flex-start;
  gap: 4px;
  padding: 0;
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.text.secondary};

  &:hover {
    background-color: transparent;
  }
`;

export const FeesChevron = styled.img<{ $collapsed: boolean }>`
  transform: rotate(${({ $collapsed }) => ($collapsed ? 180 : 0)}deg);
  transition: transform 0.2s ease-in-out;
`;

export const FeesDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  padding-left: 8px;
  border-left: 1px solid ${({ theme }) => theme.colors.border};

  /* The display above would otherwise beat the user-agent rule behind the hidden attribute. */
  &[hidden] {
    display: none;
  }
`;

export const FeesNote = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Divider = styled.hr`
  width: 100%;
  margin: 0;
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
`;

export const RestrictedAssignContent = styled.section`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text.secondary};
  padding: 18px;
  padding-top: 0;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin-top: 32px;

  & button {
    padding: 8px 20px;
    border-radius: 100px;
    font-weight: 700;

    &:first-child {
      background-color: ${({ theme }) => theme.colors.button.hover.secondary};
      color: ${({ theme }) => theme.colors.button.text.secondary};
    }
  }
`;
